import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

/**
 * Hook customizado para detectar se a tela é mobile
 * @returns {boolean} - true se for mobile, false caso contrário
 */
export const useIsMobile = () => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('md'));
};

export default useIsMobile;
